import { Box } from "@material-ui/core"
import Clear from "@material-ui/icons/Clear"
import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { LinkButton } from "../link-button/link-button.component"

import "./clear-filters-button.styles.scss"

export interface IClearFiltersButtonProps {
  onClick: () => void
}

export function ClearFiltersButton(props: IClearFiltersButtonProps): ReactElement {
  const { onClick } = props
  const { t } = useTranslation("search")

  return (
    <Box className={"clear-filters-container"}>
      <LinkButton onClick={onClick}>
        <Clear />
        {t("filtering.removeFilters")}
      </LinkButton>
    </Box>
  )
}
